import { useCallback } from 'react';

import { useToasts } from 'dibs-toaster/exports/useToasts.ts';

import { AddToFolderToastContent, RemoveFromFolderToastContent } from './FolderToastsContent.tsx';
import { SHARED_TOAST_PROPS } from './sharedToastProps.ts';
import { trackItemFavoritingToast } from './tracking.ts';

const useFolderToasts = (): {
    addToFolderToast: (portfolio: { portfolioId: string; portfolioName: string }) => void;
    removeFromFolderToast: (portfolio: { portfolioName: string }) => void;
} => {
    const { addToast } = useToasts();

    const addToFolderToast = useCallback(
        ({ portfolioId, portfolioName }: { portfolioId: string; portfolioName: string }) => {
            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: (
                        <AddToFolderToastContent
                            portfolioId={portfolioId}
                            portfolioName={portfolioName}
                        />
                    ),
                },
            });
            trackItemFavoritingToast({ trigger: 'foldered' });
        },
        [addToast]
    );

    const removeFromFolderToast = useCallback(
        ({ portfolioName }: { portfolioName: string }) => {
            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: <RemoveFromFolderToastContent portfolioName={portfolioName} />,
                },
            });
            trackItemFavoritingToast({ trigger: 'folder removed' });
        },
        [addToast]
    );

    return {
        addToFolderToast,
        removeFromFolderToast,
    };
};

export { useFolderToasts };
